export default "__VITE_ASSET__5973ed49__"